import { empApi } from "./client";

// Thống kê thu nhập của tôi
export const getIncomeStatisticApi = (params) =>
  empApi.get("/estimatedCommission/app/myTotal", params);

// Danh sách theo loại
export const getIncomeProvisionalListApi = (params) =>
  empApi.get("/estimatedCommission/app/myProvisionalCommission", params);
export const getIncomeComparativeListApi = (params) =>
  empApi.get("/commission/my/list/locking/comparative", params);
export const getIncomePaidListApi = (params) =>
  empApi.get("/commission/my/list/locking/paid", params);
// Giao dịch đã tính PDV nhưng chưa được chi trả hết (Chờ / Đang thanh toán)
export const getIncomeUnpaidListApi = (params) =>
  empApi.get("/commission/my/list/locking/unpaid", params);

// Chi tiết theo loại
export const getIncomeProvisionalDetailApi = (id) =>
  empApi.get(`/estimatedCommission/app/getDetailProvisionalEstimated/${id}`);
export const getIncomeComparativeDetailApi = (id) =>
  empApi.get(`/estimatedCommission/app/getDetailCompare/${id}`);
export const getIncomePaidDetailApi = (id) =>
  empApi.get(`/estimatedCommission/app/getDetailPaid/${id}`);

// Giải ngân PDV (tab Giải ngân của Thu nhập chi trả) — id = locking._id
export const getIncomePaidDisbursementApi = (id) =>
  empApi.get(`/serviceFee/app/disbursement/paid/${id}`);

// ===== Kiểm tra giao dịch (xem thu nhập theo góc nhìn nhân viên) =====
// Khớp nhóm VIEW_AS_* của app: dùng bộ endpoint checkTransaction riêng,
// không dùng chung với các API thu nhập cá nhân.
export const verifyViewAsParticipationApi = (params) =>
  empApi.get("/checkTransaction/app/verifyParticipation", params);

export const getViewAsIncomeStatisticApi = (params) =>
  empApi.get("/checkTransaction/app/myTotal", params);

export const getViewAsProvisionalListApi = (params) =>
  empApi.get("/checkTransaction/app/myProvisionalCommission", params);
export const getViewAsComparativeListApi = (params) =>
  empApi.get("/checkTransaction/app/comparative", params);
export const getViewAsPaidListApi = (params) =>
  empApi.get("/checkTransaction/app/paid", params);

export const getViewAsProvisionalDetailApi = (id, params) =>
  empApi.get(`/checkTransaction/app/getDetailProvisionalEstimated/${id}`, params);
export const getViewAsComparativeDetailApi = (id, params) =>
  empApi.get(`/checkTransaction/app/getDetailCompare/${id}`, params);
export const getViewAsPaidDetailApi = (id, params) =>
  empApi.get(`/checkTransaction/app/getDetailPaid/${id}`, params);

export const getViewAsDisbursementPaidApi = (id, params) =>
  empApi.get(`/checkTransaction/app/disbursement/paid/${id}`, params);
